import React, { FC } from "react";
import { DatePicker } from "../../atoms/DatePicker";
import { InputField, InputTitle } from "./elements";
import { DatePickerProps } from "./types";
import ConditionalWrapper from "../../../utils/helpers/ConditionalWrapper";

const DatePickerWithLabel: FC<DatePickerProps> = (props) => {
  const {
    label,
    onChange,
    width,
    picker,
    value,
    disabled,
    getPopupContainer,
    spanId,
  } = props;

  return (
    <InputField>
      <InputTitle>{label}</InputTitle>
      <ConditionalWrapper
        condition={spanId}
        wrapper={(children: any) => <span id={spanId}>{children}</span>}
      >
        <DatePicker
          onChange={onChange}
          width={width}
          picker={picker}
          value={value}
          disabled={disabled}
          getPopupContainer={getPopupContainer}
        />
      </ConditionalWrapper>
    </InputField>
  );
};

export default DatePickerWithLabel;
